export default function DashboardInputToolbar({
  showFilterToggle = false,
  showFilters = false,
  onToggleFilters,
  countText = '',
  showAdd = false,
  onAdd,
  addLabel = '+ レコード追加',
  showApplyTemplate = false,
  onApplyTemplate,
  applyTemplateLabel = 'テンプレートから追加',
  showExport = false,
  exporting = false,
  onExport,
}) {
  return (
    <div className="pm-top-controls">
      <div className="pm-top-controls-left">
        {showFilterToggle && (
          <button
            className="pm-filter-toggle"
            onClick={onToggleFilters}
            type="button"
          >
            {showFilters ? 'フィルターを閉じる' : 'フィルターを開く'}
          </button>
        )}
        {countText && <p className="pm-filter-count">{countText}</p>}
      </div>

      <div className="pm-top-controls-right">
        {showExport && (
          <button className="pm-filter-clear" disabled={exporting} onClick={onExport} type="button">
            {exporting ? '出力中...' : 'エクスポート'}
          </button>
        )}
        {showApplyTemplate && (
          <button className="pm-add-button" onClick={onApplyTemplate} type="button">
            {applyTemplateLabel}
          </button>
        )}
        {showAdd && (
          <button className="pm-add-button" onClick={onAdd} type="button">
            {addLabel}
          </button>
        )}
      </div>
    </div>
  );
}
